import React, { useEffect, useState } from 'react';
import { Thought } from '../types';
import { ContentService } from '../services/content';
const Notes: React.FC = () => {
  const [thoughts, setThoughts] = useState<Thought[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchThoughts = async () => {
      try {
        const data = await ContentService.getThoughts();
        setThoughts(data);
      } catch (err) {
        console.error('Notes Page: Error fetching thoughts', err);
      } finally {
        setLoading(false);
      }
    };
    fetchThoughts();
  }, []);
  if (loading) return <div className="min-h-screen bg-black flex items-center justify-center" data-id="element-251">
        <div className="flex flex-col items-center gap-6" data-id="element-252">
          <div className="w-12 h-12 border-t-2 border-white rounded-full animate-spin" data-id="element-253" />
          <span className="text-[10px] uppercase tracking-[0.5em] text-zinc-500 font-black animate-pulse" data-id="element-254">
            loading_dopamine_loops
          </span>
        </div>
      </div>;
  return <div className="max-w-screen-2xl mx-auto px-6 md:px-12 pt-[104px] md:pt-32 pb-48 min-h-screen relative z-10" data-id="element-255">
      <header className="mb-12 md:mb-32" data-id="element-256">
        <div className="flex flex-col space-y-6" data-id="element-257">
          <div className="flex items-center gap-4" data-id="element-258">
            <h1 className="text-6xl md:text-[12rem] font-extrabold tracking-tighter lowercase leading-[0.8] animate-in fade-in slide-in-from-top-4 duration-700" data-id="element-259">
              <span className="mr-4 opacity-80" data-id="element-260">🧠</span>
              thoughts
            </h1>
          </div>
          <p className="text-xl md:text-4xl text-zinc-400 font-medium lowercase max-w-4xl leading-tight opacity-70" data-id="element-261">
            Atomic insights on building products, mastering craft, and
            optimizing the creative engine.
          </p>
        </div>
      </header>

      <section className="mb-12 md:mb-48 relative z-[60]" data-id="element-262">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8 lg:gap-10" data-id="element-263">
          {thoughts && thoughts.length > 0 ? thoughts.map(thought => <div key={thought.id} className="group relative flex flex-col justify-between p-8 md:p-12 min-h-[260px] md:min-h-[360px] bg-zinc-900 border border-white/20 rounded-sm overflow-hidden transition-all duration-700 ease-[cubic-bezier(0.19,1,0.22,1)] hover:-translate-y-4 hover:scale-[1.02] hover:bg-zinc-800/80 hover:border-white/40 hover:shadow-[0_40px_120px_-30px_rgba(255,255,255,0.1)] cursor-target animate-in fade-in zoom-in-95 duration-500" data-id="element-264">
                <div className="absolute inset-0 bg-gradient-to-br from-white/[0.03] to-transparent pointer-events-none" data-id="element-265" />

                <div className="relative z-10 space-y-4" data-id="element-266">
                  <div className="flex justify-between items-start" data-id="element-267">
                    <span className="text-[12px] text-zinc-400 uppercase tracking-[0.4em] font-black group-hover:text-white transition-colors" data-id="element-268">
                      {thought.category || 'Thought'}
                    </span>
                    <div className="w-2.5 h-2.5 rounded-full bg-white/10 group-hover:bg-white animate-pulse transition-all duration-300 shadow-[0_0_15px_rgba(255,255,255,0.5)]" data-id="element-269" />
                  </div>
                </div>

                <div className="relative z-10 flex-grow flex flex-col justify-center" data-id="element-270">
                  <h3 className="text-2xl md:text-[clamp(1.4rem,3.2vw,2.4rem)] font-extrabold tracking-tighter leading-[1.05] lowercase group-hover:text-white transition-colors duration-500 max-w-[20ch] md:max-w-[24ch] break-words" data-id="element-271">
                    {thought.title}
                  </h3>
                </div>
              </div>) : <div className="col-span-full py-48 text-center border border-dashed border-white/10 rounded-sm bg-zinc-900/10 items-center justify-center" data-id="element-272">
              <span className="text-6xl block mb-8 opacity-10 grayscale" data-id="element-273">
                📥
              </span>
              <p className="text-zinc-500 text-2xl font-medium lowercase tracking-tight" data-id="element-274">
                System synchronization in progress...
              </p>
            </div>}
        </div>
      </section>
    </div>;
};
export default Notes;